module.exports = __webpack_public_path__ + "img/coupon.7e372962.png";